export default __webpack_public_path__ + "static/media/B12.74b9aa43.png";